(() => {
  const SERVICE_CONFIG = Object.freeze({
    TPV: {
      question: '¿Qué necesitas exactamente?',
      options: [
        'Un kit TPV completo',
        'Solo un accesorio o componente',
        'Solo el software',
        'No estoy seguro, necesito asesoramiento',
      ],
    },
    'Renting de pantallas publicitarias': {
      question: '¿Qué tipo de pantalla necesitas según dónde se va a instalar?',
      options: [
        'Escaparate muy expuesto a la luz o al sol',
        'Escaparate en sombra o con poca incidencia solar',
        'Interior de local',
        'No lo tengo claro, necesito recomendación',
      ],
    },
    'Compra de pantallas publicitarias': {
      question: '¿Qué tipo de pantalla necesitas según dónde se vaya a instalar?',
      options: [
        'Escaparate muy expuesto a la luz o al sol',
        'Escaparate en sombra o con poca incidencia solar',
        'Interior de local',
        'No lo tengo claro, necesito recomendación',
      ],
    },
  });

  const PHONE_CONTACT_METHODS = new Set(['Llamada', 'WhatsApp']);

  const slugify = (value) =>
    value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'contacto';

  const buildFallbackEmail = (phoneValue, contactMethod, domain) => {
    const phoneToken = phoneValue.replace(/[^0-9a-z]/gi, '').slice(-12) || 'sin-telefono';
    const methodToken = slugify(contactMethod);
    return `sin-email+${methodToken}-${phoneToken}@${domain}`;
  };

  const populateSelectOptions = (select, config) => {
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = config.question;
    placeholder.disabled = true;
    placeholder.selected = true;

    const options = config.options.map((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      return option;
    });

    select.replaceChildren(placeholder, ...options);
  };

  const initDynamicContactForm = (root) => {
    if (root.dataset.dynamicInitialized === 'true') return;

    const form = root.querySelector('form');
    const contactMethod = root.querySelector('[data-contact-method]');
    const serviceInterest = root.querySelector('[data-service-interest]');
    const serviceDetailWrapper = root.querySelector('[data-service-detail-wrapper]');
    const serviceDetailLabel = root.querySelector('[data-service-detail-label]');
    const serviceDetail = root.querySelector('[data-service-detail]');
    const otherDetailsWrapper = root.querySelector('[data-other-details-wrapper]');
    const otherDetails = root.querySelector('[data-other-details]');
    const phoneInput = root.querySelector('[data-phone-input]');
    const emailDisplay = root.querySelector('[data-email-display]');
    const emailSubmit = root.querySelector('[data-email-submit]');

    if (
      !form ||
      !(contactMethod instanceof HTMLSelectElement) ||
      !(serviceInterest instanceof HTMLSelectElement) ||
      !(serviceDetailWrapper instanceof HTMLElement) ||
      !(serviceDetailLabel instanceof HTMLElement) ||
      !(serviceDetail instanceof HTMLSelectElement) ||
      !(otherDetailsWrapper instanceof HTMLElement) ||
      !(otherDetails instanceof HTMLTextAreaElement) ||
      !(phoneInput instanceof HTMLInputElement) ||
      !(emailDisplay instanceof HTMLInputElement) ||
      !(emailSubmit instanceof HTMLInputElement)
    ) {
      return;
    }

    const fallbackEmailDomain = root.dataset.fallbackEmailDomain || 'nioxtec.invalid';

    const syncEmailSubmitValue = ({ useFallbackIfNeeded = false } = {}) => {
      const visibleEmail = emailDisplay.value.trim();
      if (visibleEmail !== '') {
        emailSubmit.value = visibleEmail;
        return;
      }

      if (useFallbackIfNeeded && PHONE_CONTACT_METHODS.has(contactMethod.value)) {
        emailSubmit.value = buildFallbackEmail(phoneInput.value, contactMethod.value, fallbackEmailDomain);
        return;
      }

      emailSubmit.value = '';
    };

    const updateContactMethodState = () => {
      const method = contactMethod.value;
      const phoneRequired = PHONE_CONTACT_METHODS.has(method);
      const emailRequired = method === 'Correo electrónico';

      phoneInput.required = phoneRequired;
      emailDisplay.required = emailRequired;
      phoneInput.setCustomValidity('');
      emailDisplay.setCustomValidity('');

      syncEmailSubmitValue();
    };

    const updateServiceState = ({ resetValues = false } = {}) => {
      const selectedService = serviceInterest.value;
      const previousService = root.dataset.activeService || '';
      const serviceChanged = selectedService !== previousService;
      const config = SERVICE_CONFIG[selectedService];
      const useOtherDetails = selectedService === 'Otros';

      if (resetValues) {
        serviceDetail.value = '';
        otherDetails.value = '';
      }

      if (config) {
        if (serviceChanged || serviceDetail.options.length <= 1) {
          populateSelectOptions(serviceDetail, config);
        }

        if (serviceChanged || resetValues) {
          serviceDetail.value = '';
        }

        serviceDetailLabel.textContent = config.question;
        serviceDetail.setAttribute('aria-label', config.question);
        serviceDetailWrapper.hidden = false;
        serviceDetail.disabled = false;
        serviceDetail.required = true;
      } else {
        serviceDetail.replaceChildren();
        serviceDetailWrapper.hidden = true;
        serviceDetail.disabled = true;
        serviceDetail.required = false;
        serviceDetail.value = '';
      }

      otherDetailsWrapper.hidden = !useOtherDetails;
      otherDetails.disabled = !useOtherDetails;
      otherDetails.required = false;

      if (!useOtherDetails) {
        otherDetails.value = '';
      }

      root.dataset.activeService = selectedService;
    };

    contactMethod.addEventListener('change', updateContactMethodState);
    serviceInterest.addEventListener('change', () => updateServiceState({ resetValues: true }));
    emailDisplay.addEventListener('input', () => {
      emailDisplay.setCustomValidity('');
      syncEmailSubmitValue();
    });
    phoneInput.addEventListener('input', () => {
      phoneInput.setCustomValidity('');
      syncEmailSubmitValue();
    });

    form.addEventListener('submit', (event) => {
      updateContactMethodState();
      updateServiceState();

      if (PHONE_CONTACT_METHODS.has(contactMethod.value) && phoneInput.value.trim() === '') {
        phoneInput.setCustomValidity('Indícanos un teléfono para poder contactarte.');
      }

      if (contactMethod.value === 'Correo electrónico' && emailDisplay.value.trim() === '') {
        emailDisplay.setCustomValidity('Indícanos un correo electrónico para poder contactarte.');
      }

      syncEmailSubmitValue({ useFallbackIfNeeded: true });

      if (!form.reportValidity()) {
        event.preventDefault();
        syncEmailSubmitValue();
      }
    });

    updateServiceState();
    updateContactMethodState();
    root.dataset.dynamicInitialized = 'true';
  };

  const initAllDynamicContactForms = () => {
    document
      .querySelectorAll('[data-contact-form-mode="dynamic_service_qualifier"]')
      .forEach((root) => initDynamicContactForm(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDynamicContactForms, { once: true });
  } else {
    initAllDynamicContactForms();
  }
})();
